export default [
  // 比赛中心
  {
    path: '/contest',
    name: 'contest',
    meta: { title: "比赛中心" },
    component: () => import('@/views/pages/contest/list.vue')
  },
  // 比赛完成
  {
    path: '/contest/:contestID/end',
    name: 'end',
    meta: { title: "比赛完成" },
    component: () => import('@/views/pages/contest/section/end.vue')
  },
  // 比赛详情
  {
    path: '/contest/:contestID/',
    component: () => import('@/views/pages/contest/details/index.vue'),
    redirect: '/contest/:contestID/',
    children: [
      {
        path: 'introduce',
        meta: { title: "比赛介绍" },
        name: 'introduce',
        component: () => import('@/views/pages/contest/details/introduce.vue'),
      },
      {
        path: '',
        meta: { title: "比赛试题" },
        name: 'introduce',
        component: () => import('@/views/pages/contest/details/introduce.vue'),
      },
      {
        path: 'list',
        meta: { title: "比赛试题" },
        name: 'list',
        component: () => import('@/views/pages/contest/details/catalogue.vue'),
      },
      {
        path: 'grade',
        meta: { title: "我的成绩" },
        name: 'grade',
        component: () => import('@/views/pages/contest/details/grade.vue'),
      },
      {
        path: 'rank',
        meta: { title: "比赛榜单" },
        name: 'rank',
        component: () => import('@/views/pages/contest/details/rank.vue'),
      },
      {
        path: 'notification',
        meta: { title: "比赛公告" },
        name: 'notification',
        component: () => import('@/views/pages/contest/details/notification.vue'),
      }
    ]
  },
  // 比赛赛题试卷
  {
    path: '/paper/:contestID/:chapterID/:sectionID',
    name: 'title',
    meta: { title: "赛题试卷" },
    component: () => import('@/views/pages/contest/paper/index.vue'),
  },
  {
    path: '/paper/:contestID/:chapterID/:sectionID/title',
    name: 'title',
    meta: { title: "题目描述" },
    component: () => import('@/views/pages/contest/paper/index.vue'),
  },
  {
    path: '/paper/:contestID/:chapterID/:sectionID/result',
    name: 'result',
    meta: { title: "题目描述" },
    component: () => import('@/views/pages/contest/paper/index.vue'),
  },
  {
    path: '/paper/:contestID/:chapterID/:sectionID/submissions',
    name: 'submissions',
    meta: { title: "提交记录" },
    component: () => import('@/views/pages/contest/paper/index.vue'),
  },

  // 比赛赛题
  {
    path: '/contest/:contestID/:chapterID/:sectionID',
    name: 'title',
    meta: { title: "题目描述" },
    component: () => import('@/views/pages/contest/section/index.vue'),
  },
  {
    path: '/contest/:contestID/:chapterID/:sectionID/title',
    name: 'title',
    meta: { title: "题目描述" },
    component: () => import('@/views/pages/contest/section/index.vue'),
  },
  // {
  //   path: '/contest/:contestID/:chapterID/:sectionID/solution',
  //   name: 'solution',
  //   meta: { title: "题解" },
  //   component: () => import('@/views/pages/contest/section/index.vue'),
  // },
  {
    path: '/contest/:contestID/:chapterID/:sectionID/result',
    name: 'result',
    meta: { title: "运行结果" },
    component: () => import('@/views/pages/contest/section/index.vue'),
  },
  {
    path: '/contest/:contestID/:chapterID/:sectionID/submissions',
    name: 'submissions',
    meta: { title: "提交记录" },
    component: () => import('@/views/pages/contest/section/index.vue'),
  },
]
